/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateSupportAdminMessageDto } from '../models';
// @ts-ignore
import type { SupportAdminDocumentLookupResponseDto } from '../models';
// @ts-ignore
import type { SupportAdminShopStateDto } from '../models';
// @ts-ignore
import type { SupportAdminTicketDetailDto } from '../models';
// @ts-ignore
import type { SupportAdminTicketListResponseDto } from '../models';
// @ts-ignore
import type { SupportAgentDto } from '../models';
// @ts-ignore
import type { UpdateSupportTicketAssigneeDto } from '../models';
// @ts-ignore
import type { UpdateSupportTicketCategoryDto } from '../models';
// @ts-ignore
import type { UpdateSupportTicketPriorityDto } from '../models';
// @ts-ignore
import type { UpdateSupportTicketStatusDto } from '../models';
/**
 * SupportAdminApi - axios parameter creator
 * @export
 */
export const SupportAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds an INTERNAL message. Never visible to the merchant, never counts as a first response, never changes the status. Send expectedStateToken to have the note refused if the ticket changed after it was read.
         * @summary Add an internal note to a support ticket
         * @param {string} id Support ticket id
         * @param {CreateSupportAdminMessageDto} createSupportAdminMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupportTicketNote: async (id: string, createSupportAdminMessageDto: CreateSupportAdminMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addSupportTicketNote', 'id', id)
            // verify required parameter 'createSupportAdminMessageDto' is not null or undefined
            assertParamExists('addSupportTicketNote', 'createSupportAdminMessageDto', createSupportAdminMessageDto)
            const localVarPath = `/v1/support-admin/tickets/{id}/notes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSupportAdminMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Streams the file, including attachments on internal notes, across shops. Every download is written to the operator audit log.
         * @summary Download a support attachment as an agent
         * @param {string} id Attachment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSupportAdminAttachment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadSupportAdminAttachment', 'id', id)
            const localVarPath = `/v1/support-admin/attachments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Includes internal notes, the event trail, the environment snapshot captured when the ticket was opened, and the statuses this ticket may legally move to.
         * @summary Get one support ticket with the full thread
         * @param {string} id Support ticket id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportAdminTicket: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSupportAdminTicket', 'id', id)
            const localVarPath = `/v1/support-admin/tickets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The live counterpart to the ticket\'s frozen contextSnapshot: the same keys read again now, which of them changed since, plus the facts that only make sense live — last invoice issued, documents stuck in a terminal failure, last webhook received, and the shop\'s unresolved alerts.
         * @summary Read the ticket\'s shop as it stands right now
         * @param {string} id Support ticket id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportTicketShopState: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSupportTicketShopState', 'id', id)
            const localVarPath = `/v1/support-admin/tickets/{id}/shop-state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The working queue, sorted by first-response deadline so the most at-risk ticket is first. Filterable by status, category, priority, tier, assignee and overdue, with free text over subject, shop domain and ticket reference.
         * @summary List support tickets across all shops
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {ListSupportAdminTicketsStatusEnum} [status] 
         * @param {ListSupportAdminTicketsCategoryEnum} [category] 
         * @param {ListSupportAdminTicketsPriorityEnum} [priority] 
         * @param {string} [assignee] Operator username, or \&quot;unassigned\&quot;
         * @param {ListSupportAdminTicketsTierEnum} [tier] Plan tier frozen on the ticket at creation
         * @param {boolean} [overdue] Only tickets past their first-response deadline
         * @param {string} [search] Free text over subject, reference and shop domain
         * @param {ListSupportAdminTicketsScopeEnum} [scope] Which slice of the queue. \&#39;open\&#39; is the working view; \&#39;all\&#39; includes finished tickets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportAdminTickets: async (page?: number, limit?: number, status?: ListSupportAdminTicketsStatusEnum, category?: ListSupportAdminTicketsCategoryEnum, priority?: ListSupportAdminTicketsPriorityEnum, assignee?: string, tier?: ListSupportAdminTicketsTierEnum, overdue?: boolean, search?: string, scope?: ListSupportAdminTicketsScopeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/support-admin/tickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (priority !== undefined) {
                localVarQueryParameter['priority'] = priority;
            }

            if (assignee !== undefined) {
                localVarQueryParameter['assignee'] = assignee;
            }

            if (tier !== undefined) {
                localVarQueryParameter['tier'] = tier;
            }

            if (overdue !== undefined) {
                localVarQueryParameter['overdue'] = overdue;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The operator accounts that can currently sign in. Passwords are never returned.
         * @summary List the configured support operators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportAgents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/support-admin/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Searches all three document tables by the number as the merchant\'s own document is headed, and invoices additionally by order name and order id. An order-shaped term returns the invoice together with the credit notes and cancellation invoices that hang off it. Pass shopId whenever the lookup starts from a ticket — it is what makes the shop\'s prefix and year digits interpretable.
         * @summary Find invoices, credit notes and Stornos by number or order
         * @param {string} q A document number as the merchant quoted it (RE-26392, 26392), a Shopify order name (#1001) or an order id
         * @param {string} [shopId] Scope the search to one shop. Pass the ticket\&#39;s shopId whenever the lookup starts from a ticket: it is what makes the shop\&#39;s own prefix and year digits interpretable, and it is the only form of this query that an index can serve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupSupportDocuments: async (q: string, shopId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('lookupSupportDocuments', 'q', q)
            const localVarPath = `/v1/support-admin/documents/lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (shopId !== undefined) {
                localVarQueryParameter['shopId'] = shopId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a PUBLIC agent message, stamps the first-response time on the first reply only, and claims an unassigned ticket for the replying operator. Optionally moves the ticket to another status in the same call. Send expectedStateToken to have the reply refused if the ticket changed after it was read.
         * @summary Reply to a support ticket
         * @param {string} id Support ticket id
         * @param {CreateSupportAdminMessageDto} createSupportAdminMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replyToSupportTicket: async (id: string, createSupportAdminMessageDto: CreateSupportAdminMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replyToSupportTicket', 'id', id)
            // verify required parameter 'createSupportAdminMessageDto' is not null or undefined
            assertParamExists('replyToSupportTicket', 'createSupportAdminMessageDto', createSupportAdminMessageDto)
            const localVarPath = `/v1/support-admin/tickets/{id}/replies`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSupportAdminMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The assignee must be a configured operator; an unknown username is refused so a typo cannot park a ticket where no filter finds it.
         * @summary Assign or unassign a support ticket
         * @param {string} id Support ticket id
         * @param {UpdateSupportTicketAssigneeDto} updateSupportTicketAssigneeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportTicketAssignee: async (id: string, updateSupportTicketAssigneeDto: UpdateSupportTicketAssigneeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSupportTicketAssignee', 'id', id)
            // verify required parameter 'updateSupportTicketAssigneeDto' is not null or undefined
            assertParamExists('updateSupportTicketAssignee', 'updateSupportTicketAssigneeDto', updateSupportTicketAssigneeDto)
            const localVarPath = `/v1/support-admin/tickets/{id}/assignee`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSupportTicketAssigneeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refused when the ticket currently sits in a status the new category does not allow, rather than silently moving it.
         * @summary Recategorise a support ticket
         * @param {string} id Support ticket id
         * @param {UpdateSupportTicketCategoryDto} updateSupportTicketCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportTicketCategory: async (id: string, updateSupportTicketCategoryDto: UpdateSupportTicketCategoryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSupportTicketCategory', 'id', id)
            // verify required parameter 'updateSupportTicketCategoryDto' is not null or undefined
            assertParamExists('updateSupportTicketCategory', 'updateSupportTicketCategoryDto', updateSupportTicketCategoryDto)
            const localVarPath = `/v1/support-admin/tickets/{id}/category`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSupportTicketCategoryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change a support ticket priority
         * @param {string} id Support ticket id
         * @param {UpdateSupportTicketPriorityDto} updateSupportTicketPriorityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportTicketPriority: async (id: string, updateSupportTicketPriorityDto: UpdateSupportTicketPriorityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSupportTicketPriority', 'id', id)
            // verify required parameter 'updateSupportTicketPriorityDto' is not null or undefined
            assertParamExists('updateSupportTicketPriority', 'updateSupportTicketPriorityDto', updateSupportTicketPriorityDto)
            const localVarPath = `/v1/support-admin/tickets/{id}/priority`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSupportTicketPriorityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validated against the shared transition table and the category restriction, so the backlog statuses stay reachable only for feature requests and feedback.
         * @summary Change a support ticket status
         * @param {string} id Support ticket id
         * @param {UpdateSupportTicketStatusDto} updateSupportTicketStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportTicketStatus: async (id: string, updateSupportTicketStatusDto: UpdateSupportTicketStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSupportTicketStatus', 'id', id)
            // verify required parameter 'updateSupportTicketStatusDto' is not null or undefined
            assertParamExists('updateSupportTicketStatus', 'updateSupportTicketStatusDto', updateSupportTicketStatusDto)
            const localVarPath = `/v1/support-admin/tickets/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSupportTicketStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportAdminApi - functional programming interface
 * @export
 */
export const SupportAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupportAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds an INTERNAL message. Never visible to the merchant, never counts as a first response, never changes the status. Send expectedStateToken to have the note refused if the ticket changed after it was read.
         * @summary Add an internal note to a support ticket
         * @param {string} id Support ticket id
         * @param {CreateSupportAdminMessageDto} createSupportAdminMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSupportTicketNote(id: string, createSupportAdminMessageDto: CreateSupportAdminMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportAdminTicketDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSupportTicketNote(id, createSupportAdminMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.addSupportTicketNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Streams the file, including attachments on internal notes, across shops. Every download is written to the operator audit log.
         * @summary Download a support attachment as an agent
         * @param {string} id Attachment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSupportAdminAttachment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSupportAdminAttachment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.downloadSupportAdminAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Includes internal notes, the event trail, the environment snapshot captured when the ticket was opened, and the statuses this ticket may legally move to.
         * @summary Get one support ticket with the full thread
         * @param {string} id Support ticket id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportAdminTicket(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportAdminTicketDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportAdminTicket(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.getSupportAdminTicket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The live counterpart to the ticket\'s frozen contextSnapshot: the same keys read again now, which of them changed since, plus the facts that only make sense live — last invoice issued, documents stuck in a terminal failure, last webhook received, and the shop\'s unresolved alerts.
         * @summary Read the ticket\'s shop as it stands right now
         * @param {string} id Support ticket id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportTicketShopState(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportAdminShopStateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportTicketShopState(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.getSupportTicketShopState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The working queue, sorted by first-response deadline so the most at-risk ticket is first. Filterable by status, category, priority, tier, assignee and overdue, with free text over subject, shop domain and ticket reference.
         * @summary List support tickets across all shops
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {ListSupportAdminTicketsStatusEnum} [status] 
         * @param {ListSupportAdminTicketsCategoryEnum} [category] 
         * @param {ListSupportAdminTicketsPriorityEnum} [priority] 
         * @param {string} [assignee] Operator username, or \&quot;unassigned\&quot;
         * @param {ListSupportAdminTicketsTierEnum} [tier] Plan tier frozen on the ticket at creation
         * @param {boolean} [overdue] Only tickets past their first-response deadline
         * @param {string} [search] Free text over subject, reference and shop domain
         * @param {ListSupportAdminTicketsScopeEnum} [scope] Which slice of the queue. \&#39;open\&#39; is the working view; \&#39;all\&#39; includes finished tickets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupportAdminTickets(page?: number, limit?: number, status?: ListSupportAdminTicketsStatusEnum, category?: ListSupportAdminTicketsCategoryEnum, priority?: ListSupportAdminTicketsPriorityEnum, assignee?: string, tier?: ListSupportAdminTicketsTierEnum, overdue?: boolean, search?: string, scope?: ListSupportAdminTicketsScopeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportAdminTicketListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupportAdminTickets(page, limit, status, category, priority, assignee, tier, overdue, search, scope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.listSupportAdminTickets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The operator accounts that can currently sign in. Passwords are never returned.
         * @summary List the configured support operators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupportAgents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupportAgentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupportAgents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.listSupportAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Searches all three document tables by the number as the merchant\'s own document is headed, and invoices additionally by order name and order id. An order-shaped term returns the invoice together with the credit notes and cancellation invoices that hang off it. Pass shopId whenever the lookup starts from a ticket — it is what makes the shop\'s prefix and year digits interpretable.
         * @summary Find invoices, credit notes and Stornos by number or order
         * @param {string} q A document number as the merchant quoted it (RE-26392, 26392), a Shopify order name (#1001) or an order id
         * @param {string} [shopId] Scope the search to one shop. Pass the ticket\&#39;s shopId whenever the lookup starts from a ticket: it is what makes the shop\&#39;s own prefix and year digits interpretable, and it is the only form of this query that an index can serve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookupSupportDocuments(q: string, shopId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportAdminDocumentLookupResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookupSupportDocuments(q, shopId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.lookupSupportDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds a PUBLIC agent message, stamps the first-response time on the first reply only, and claims an unassigned ticket for the replying operator. Optionally moves the ticket to another status in the same call. Send expectedStateToken to have the reply refused if the ticket changed after it was read.
         * @summary Reply to a support ticket
         * @param {string} id Support ticket id
         * @param {CreateSupportAdminMessageDto} createSupportAdminMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replyToSupportTicket(id: string, createSupportAdminMessageDto: CreateSupportAdminMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportAdminTicketDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replyToSupportTicket(id, createSupportAdminMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.replyToSupportTicket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The assignee must be a configured operator; an unknown username is refused so a typo cannot park a ticket where no filter finds it.
         * @summary Assign or unassign a support ticket
         * @param {string} id Support ticket id
         * @param {UpdateSupportTicketAssigneeDto} updateSupportTicketAssigneeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSupportTicketAssignee(id: string, updateSupportTicketAssigneeDto: UpdateSupportTicketAssigneeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportAdminTicketDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupportTicketAssignee(id, updateSupportTicketAssigneeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.updateSupportTicketAssignee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refused when the ticket currently sits in a status the new category does not allow, rather than silently moving it.
         * @summary Recategorise a support ticket
         * @param {string} id Support ticket id
         * @param {UpdateSupportTicketCategoryDto} updateSupportTicketCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSupportTicketCategory(id: string, updateSupportTicketCategoryDto: UpdateSupportTicketCategoryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportAdminTicketDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupportTicketCategory(id, updateSupportTicketCategoryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.updateSupportTicketCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change a support ticket priority
         * @param {string} id Support ticket id
         * @param {UpdateSupportTicketPriorityDto} updateSupportTicketPriorityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSupportTicketPriority(id: string, updateSupportTicketPriorityDto: UpdateSupportTicketPriorityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportAdminTicketDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupportTicketPriority(id, updateSupportTicketPriorityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.updateSupportTicketPriority']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validated against the shared transition table and the category restriction, so the backlog statuses stay reachable only for feature requests and feedback.
         * @summary Change a support ticket status
         * @param {string} id Support ticket id
         * @param {UpdateSupportTicketStatusDto} updateSupportTicketStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSupportTicketStatus(id: string, updateSupportTicketStatusDto: UpdateSupportTicketStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupportAdminTicketDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupportTicketStatus(id, updateSupportTicketStatusDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAdminApi.updateSupportTicketStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupportAdminApi - factory interface
 * @export
 */
export const SupportAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupportAdminApiFp(configuration)
    return {
        /**
         * Adds an INTERNAL message. Never visible to the merchant, never counts as a first response, never changes the status. Send expectedStateToken to have the note refused if the ticket changed after it was read.
         * @summary Add an internal note to a support ticket
         * @param {SupportAdminApiAddSupportTicketNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupportTicketNote(requestParameters: SupportAdminApiAddSupportTicketNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto> {
            return localVarFp.addSupportTicketNote(requestParameters.id, requestParameters.createSupportAdminMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Streams the file, including attachments on internal notes, across shops. Every download is written to the operator audit log.
         * @summary Download a support attachment as an agent
         * @param {SupportAdminApiDownloadSupportAdminAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSupportAdminAttachment(requestParameters: SupportAdminApiDownloadSupportAdminAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.downloadSupportAdminAttachment(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Includes internal notes, the event trail, the environment snapshot captured when the ticket was opened, and the statuses this ticket may legally move to.
         * @summary Get one support ticket with the full thread
         * @param {SupportAdminApiGetSupportAdminTicketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportAdminTicket(requestParameters: SupportAdminApiGetSupportAdminTicketRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto> {
            return localVarFp.getSupportAdminTicket(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * The live counterpart to the ticket\'s frozen contextSnapshot: the same keys read again now, which of them changed since, plus the facts that only make sense live — last invoice issued, documents stuck in a terminal failure, last webhook received, and the shop\'s unresolved alerts.
         * @summary Read the ticket\'s shop as it stands right now
         * @param {SupportAdminApiGetSupportTicketShopStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportTicketShopState(requestParameters: SupportAdminApiGetSupportTicketShopStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminShopStateDto> {
            return localVarFp.getSupportTicketShopState(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * The working queue, sorted by first-response deadline so the most at-risk ticket is first. Filterable by status, category, priority, tier, assignee and overdue, with free text over subject, shop domain and ticket reference.
         * @summary List support tickets across all shops
         * @param {SupportAdminApiListSupportAdminTicketsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportAdminTickets(requestParameters: SupportAdminApiListSupportAdminTicketsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketListResponseDto> {
            return localVarFp.listSupportAdminTickets(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.category, requestParameters.priority, requestParameters.assignee, requestParameters.tier, requestParameters.overdue, requestParameters.search, requestParameters.scope, options).then((request) => request(axios, basePath));
        },
        /**
         * The operator accounts that can currently sign in. Passwords are never returned.
         * @summary List the configured support operators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportAgents(options?: RawAxiosRequestConfig): AxiosPromise<Array<SupportAgentDto>> {
            return localVarFp.listSupportAgents(options).then((request) => request(axios, basePath));
        },
        /**
         * Searches all three document tables by the number as the merchant\'s own document is headed, and invoices additionally by order name and order id. An order-shaped term returns the invoice together with the credit notes and cancellation invoices that hang off it. Pass shopId whenever the lookup starts from a ticket — it is what makes the shop\'s prefix and year digits interpretable.
         * @summary Find invoices, credit notes and Stornos by number or order
         * @param {SupportAdminApiLookupSupportDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupSupportDocuments(requestParameters: SupportAdminApiLookupSupportDocumentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminDocumentLookupResponseDto> {
            return localVarFp.lookupSupportDocuments(requestParameters.q, requestParameters.shopId, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds a PUBLIC agent message, stamps the first-response time on the first reply only, and claims an unassigned ticket for the replying operator. Optionally moves the ticket to another status in the same call. Send expectedStateToken to have the reply refused if the ticket changed after it was read.
         * @summary Reply to a support ticket
         * @param {SupportAdminApiReplyToSupportTicketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replyToSupportTicket(requestParameters: SupportAdminApiReplyToSupportTicketRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto> {
            return localVarFp.replyToSupportTicket(requestParameters.id, requestParameters.createSupportAdminMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The assignee must be a configured operator; an unknown username is refused so a typo cannot park a ticket where no filter finds it.
         * @summary Assign or unassign a support ticket
         * @param {SupportAdminApiUpdateSupportTicketAssigneeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportTicketAssignee(requestParameters: SupportAdminApiUpdateSupportTicketAssigneeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto> {
            return localVarFp.updateSupportTicketAssignee(requestParameters.id, requestParameters.updateSupportTicketAssigneeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Refused when the ticket currently sits in a status the new category does not allow, rather than silently moving it.
         * @summary Recategorise a support ticket
         * @param {SupportAdminApiUpdateSupportTicketCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportTicketCategory(requestParameters: SupportAdminApiUpdateSupportTicketCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto> {
            return localVarFp.updateSupportTicketCategory(requestParameters.id, requestParameters.updateSupportTicketCategoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change a support ticket priority
         * @param {SupportAdminApiUpdateSupportTicketPriorityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportTicketPriority(requestParameters: SupportAdminApiUpdateSupportTicketPriorityRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto> {
            return localVarFp.updateSupportTicketPriority(requestParameters.id, requestParameters.updateSupportTicketPriorityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Validated against the shared transition table and the category restriction, so the backlog statuses stay reachable only for feature requests and feedback.
         * @summary Change a support ticket status
         * @param {SupportAdminApiUpdateSupportTicketStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportTicketStatus(requestParameters: SupportAdminApiUpdateSupportTicketStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto> {
            return localVarFp.updateSupportTicketStatus(requestParameters.id, requestParameters.updateSupportTicketStatusDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupportAdminApi - interface
 * @export
 * @interface SupportAdminApi
 */
export interface SupportAdminApiInterface {
    /**
     * Adds an INTERNAL message. Never visible to the merchant, never counts as a first response, never changes the status. Send expectedStateToken to have the note refused if the ticket changed after it was read.
     * @summary Add an internal note to a support ticket
     * @param {SupportAdminApiAddSupportTicketNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    addSupportTicketNote(requestParameters: SupportAdminApiAddSupportTicketNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto>;

    /**
     * Streams the file, including attachments on internal notes, across shops. Every download is written to the operator audit log.
     * @summary Download a support attachment as an agent
     * @param {SupportAdminApiDownloadSupportAdminAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    downloadSupportAdminAttachment(requestParameters: SupportAdminApiDownloadSupportAdminAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Includes internal notes, the event trail, the environment snapshot captured when the ticket was opened, and the statuses this ticket may legally move to.
     * @summary Get one support ticket with the full thread
     * @param {SupportAdminApiGetSupportAdminTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    getSupportAdminTicket(requestParameters: SupportAdminApiGetSupportAdminTicketRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto>;

    /**
     * The live counterpart to the ticket\'s frozen contextSnapshot: the same keys read again now, which of them changed since, plus the facts that only make sense live — last invoice issued, documents stuck in a terminal failure, last webhook received, and the shop\'s unresolved alerts.
     * @summary Read the ticket\'s shop as it stands right now
     * @param {SupportAdminApiGetSupportTicketShopStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    getSupportTicketShopState(requestParameters: SupportAdminApiGetSupportTicketShopStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminShopStateDto>;

    /**
     * The working queue, sorted by first-response deadline so the most at-risk ticket is first. Filterable by status, category, priority, tier, assignee and overdue, with free text over subject, shop domain and ticket reference.
     * @summary List support tickets across all shops
     * @param {SupportAdminApiListSupportAdminTicketsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    listSupportAdminTickets(requestParameters?: SupportAdminApiListSupportAdminTicketsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketListResponseDto>;

    /**
     * The operator accounts that can currently sign in. Passwords are never returned.
     * @summary List the configured support operators
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    listSupportAgents(options?: RawAxiosRequestConfig): AxiosPromise<Array<SupportAgentDto>>;

    /**
     * Searches all three document tables by the number as the merchant\'s own document is headed, and invoices additionally by order name and order id. An order-shaped term returns the invoice together with the credit notes and cancellation invoices that hang off it. Pass shopId whenever the lookup starts from a ticket — it is what makes the shop\'s prefix and year digits interpretable.
     * @summary Find invoices, credit notes and Stornos by number or order
     * @param {SupportAdminApiLookupSupportDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    lookupSupportDocuments(requestParameters: SupportAdminApiLookupSupportDocumentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminDocumentLookupResponseDto>;

    /**
     * Adds a PUBLIC agent message, stamps the first-response time on the first reply only, and claims an unassigned ticket for the replying operator. Optionally moves the ticket to another status in the same call. Send expectedStateToken to have the reply refused if the ticket changed after it was read.
     * @summary Reply to a support ticket
     * @param {SupportAdminApiReplyToSupportTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    replyToSupportTicket(requestParameters: SupportAdminApiReplyToSupportTicketRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto>;

    /**
     * The assignee must be a configured operator; an unknown username is refused so a typo cannot park a ticket where no filter finds it.
     * @summary Assign or unassign a support ticket
     * @param {SupportAdminApiUpdateSupportTicketAssigneeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    updateSupportTicketAssignee(requestParameters: SupportAdminApiUpdateSupportTicketAssigneeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto>;

    /**
     * Refused when the ticket currently sits in a status the new category does not allow, rather than silently moving it.
     * @summary Recategorise a support ticket
     * @param {SupportAdminApiUpdateSupportTicketCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    updateSupportTicketCategory(requestParameters: SupportAdminApiUpdateSupportTicketCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto>;

    /**
     * 
     * @summary Change a support ticket priority
     * @param {SupportAdminApiUpdateSupportTicketPriorityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    updateSupportTicketPriority(requestParameters: SupportAdminApiUpdateSupportTicketPriorityRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto>;

    /**
     * Validated against the shared transition table and the category restriction, so the backlog statuses stay reachable only for feature requests and feedback.
     * @summary Change a support ticket status
     * @param {SupportAdminApiUpdateSupportTicketStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApiInterface
     */
    updateSupportTicketStatus(requestParameters: SupportAdminApiUpdateSupportTicketStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SupportAdminTicketDetailDto>;

}

/**
 * Request parameters for addSupportTicketNote operation in SupportAdminApi.
 * @export
 * @interface SupportAdminApiAddSupportTicketNoteRequest
 */
export interface SupportAdminApiAddSupportTicketNoteRequest {
    /**
     * Support ticket id
     * @type {string}
     * @memberof SupportAdminApiAddSupportTicketNote
     */
    readonly id: string

    /**
     * 
     * @type {CreateSupportAdminMessageDto}
     * @memberof SupportAdminApiAddSupportTicketNote
     */
    readonly createSupportAdminMessageDto: CreateSupportAdminMessageDto
}

/**
 * Request parameters for downloadSupportAdminAttachment operation in SupportAdminApi.
 * @export
 * @interface SupportAdminApiDownloadSupportAdminAttachmentRequest
 */
export interface SupportAdminApiDownloadSupportAdminAttachmentRequest {
    /**
     * Attachment id
     * @type {string}
     * @memberof SupportAdminApiDownloadSupportAdminAttachment
     */
    readonly id: string
}

/**
 * Request parameters for getSupportAdminTicket operation in SupportAdminApi.
 * @export
 * @interface SupportAdminApiGetSupportAdminTicketRequest
 */
export interface SupportAdminApiGetSupportAdminTicketRequest {
    /**
     * Support ticket id
     * @type {string}
     * @memberof SupportAdminApiGetSupportAdminTicket
     */
    readonly id: string
}

/**
 * Request parameters for getSupportTicketShopState operation in SupportAdminApi.
 * @export
 * @interface SupportAdminApiGetSupportTicketShopStateRequest
 */
export interface SupportAdminApiGetSupportTicketShopStateRequest {
    /**
     * Support ticket id
     * @type {string}
     * @memberof SupportAdminApiGetSupportTicketShopState
     */
    readonly id: string
}

/**
 * Request parameters for listSupportAdminTickets operation in SupportAdminApi.
 * @export
 * @interface SupportAdminApiListSupportAdminTicketsRequest
 */
export interface SupportAdminApiListSupportAdminTicketsRequest {
    /**
     * 
     * @type {number}
     * @memberof SupportAdminApiListSupportAdminTickets
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof SupportAdminApiListSupportAdminTickets
     */
    readonly limit?: number

    /**
     * 
     * @type {'NEW' | 'OPEN' | 'PENDING_CUSTOMER' | 'UNDER_REVIEW' | 'PLANNED' | 'DECLINED' | 'RESOLVED' | 'CLOSED'}
     * @memberof SupportAdminApiListSupportAdminTickets
     */
    readonly status?: ListSupportAdminTicketsStatusEnum

    /**
     * 
     * @type {'QUESTION' | 'BUG' | 'FEATURE_REQUEST' | 'FEEDBACK' | 'BILLING' | 'TAX_COMPLIANCE' | 'DATA_EXPORT' | 'ONBOARDING' | 'OTHER'}
     * @memberof SupportAdminApiListSupportAdminTickets
     */
    readonly category?: ListSupportAdminTicketsCategoryEnum

    /**
     * 
     * @type {'LOW' | 'NORMAL' | 'HIGH' | 'URGENT'}
     * @memberof SupportAdminApiListSupportAdminTickets
     */
    readonly priority?: ListSupportAdminTicketsPriorityEnum

    /**
     * Operator username, or \&quot;unassigned\&quot;
     * @type {string}
     * @memberof SupportAdminApiListSupportAdminTickets
     */
    readonly assignee?: string

    /**
     * Plan tier frozen on the ticket at creation
     * @type {'STARTER' | 'PROFESSIONAL' | 'BUSINESS' | 'ENTERPRISE'}
     * @memberof SupportAdminApiListSupportAdminTickets
     */
    readonly tier?: ListSupportAdminTicketsTierEnum

    /**
     * Only tickets past their first-response deadline
     * @type {boolean}
     * @memberof SupportAdminApiListSupportAdminTickets
     */
    readonly overdue?: boolean

    /**
     * Free text over subject, reference and shop domain
     * @type {string}
     * @memberof SupportAdminApiListSupportAdminTickets
     */
    readonly search?: string

    /**
     * Which slice of the queue. \&#39;open\&#39; is the working view; \&#39;all\&#39; includes finished tickets.
     * @type {'open' | 'all'}
     * @memberof SupportAdminApiListSupportAdminTickets
     */
    readonly scope?: ListSupportAdminTicketsScopeEnum
}

/**
 * Request parameters for lookupSupportDocuments operation in SupportAdminApi.
 * @export
 * @interface SupportAdminApiLookupSupportDocumentsRequest
 */
export interface SupportAdminApiLookupSupportDocumentsRequest {
    /**
     * A document number as the merchant quoted it (RE-26392, 26392), a Shopify order name (#1001) or an order id
     * @type {string}
     * @memberof SupportAdminApiLookupSupportDocuments
     */
    readonly q: string

    /**
     * Scope the search to one shop. Pass the ticket\&#39;s shopId whenever the lookup starts from a ticket: it is what makes the shop\&#39;s own prefix and year digits interpretable, and it is the only form of this query that an index can serve.
     * @type {string}
     * @memberof SupportAdminApiLookupSupportDocuments
     */
    readonly shopId?: string
}

/**
 * Request parameters for replyToSupportTicket operation in SupportAdminApi.
 * @export
 * @interface SupportAdminApiReplyToSupportTicketRequest
 */
export interface SupportAdminApiReplyToSupportTicketRequest {
    /**
     * Support ticket id
     * @type {string}
     * @memberof SupportAdminApiReplyToSupportTicket
     */
    readonly id: string

    /**
     * 
     * @type {CreateSupportAdminMessageDto}
     * @memberof SupportAdminApiReplyToSupportTicket
     */
    readonly createSupportAdminMessageDto: CreateSupportAdminMessageDto
}

/**
 * Request parameters for updateSupportTicketAssignee operation in SupportAdminApi.
 * @export
 * @interface SupportAdminApiUpdateSupportTicketAssigneeRequest
 */
export interface SupportAdminApiUpdateSupportTicketAssigneeRequest {
    /**
     * Support ticket id
     * @type {string}
     * @memberof SupportAdminApiUpdateSupportTicketAssignee
     */
    readonly id: string

    /**
     * 
     * @type {UpdateSupportTicketAssigneeDto}
     * @memberof SupportAdminApiUpdateSupportTicketAssignee
     */
    readonly updateSupportTicketAssigneeDto: UpdateSupportTicketAssigneeDto
}

/**
 * Request parameters for updateSupportTicketCategory operation in SupportAdminApi.
 * @export
 * @interface SupportAdminApiUpdateSupportTicketCategoryRequest
 */
export interface SupportAdminApiUpdateSupportTicketCategoryRequest {
    /**
     * Support ticket id
     * @type {string}
     * @memberof SupportAdminApiUpdateSupportTicketCategory
     */
    readonly id: string

    /**
     * 
     * @type {UpdateSupportTicketCategoryDto}
     * @memberof SupportAdminApiUpdateSupportTicketCategory
     */
    readonly updateSupportTicketCategoryDto: UpdateSupportTicketCategoryDto
}

/**
 * Request parameters for updateSupportTicketPriority operation in SupportAdminApi.
 * @export
 * @interface SupportAdminApiUpdateSupportTicketPriorityRequest
 */
export interface SupportAdminApiUpdateSupportTicketPriorityRequest {
    /**
     * Support ticket id
     * @type {string}
     * @memberof SupportAdminApiUpdateSupportTicketPriority
     */
    readonly id: string

    /**
     * 
     * @type {UpdateSupportTicketPriorityDto}
     * @memberof SupportAdminApiUpdateSupportTicketPriority
     */
    readonly updateSupportTicketPriorityDto: UpdateSupportTicketPriorityDto
}

/**
 * Request parameters for updateSupportTicketStatus operation in SupportAdminApi.
 * @export
 * @interface SupportAdminApiUpdateSupportTicketStatusRequest
 */
export interface SupportAdminApiUpdateSupportTicketStatusRequest {
    /**
     * Support ticket id
     * @type {string}
     * @memberof SupportAdminApiUpdateSupportTicketStatus
     */
    readonly id: string

    /**
     * 
     * @type {UpdateSupportTicketStatusDto}
     * @memberof SupportAdminApiUpdateSupportTicketStatus
     */
    readonly updateSupportTicketStatusDto: UpdateSupportTicketStatusDto
}

/**
 * SupportAdminApi - object-oriented interface
 * @export
 * @class SupportAdminApi
 * @extends {BaseAPI}
 */
export class SupportAdminApi extends BaseAPI implements SupportAdminApiInterface {
    /**
     * Adds an INTERNAL message. Never visible to the merchant, never counts as a first response, never changes the status. Send expectedStateToken to have the note refused if the ticket changed after it was read.
     * @summary Add an internal note to a support ticket
     * @param {SupportAdminApiAddSupportTicketNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public addSupportTicketNote(requestParameters: SupportAdminApiAddSupportTicketNoteRequest, options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).addSupportTicketNote(requestParameters.id, requestParameters.createSupportAdminMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Streams the file, including attachments on internal notes, across shops. Every download is written to the operator audit log.
     * @summary Download a support attachment as an agent
     * @param {SupportAdminApiDownloadSupportAdminAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public downloadSupportAdminAttachment(requestParameters: SupportAdminApiDownloadSupportAdminAttachmentRequest, options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).downloadSupportAdminAttachment(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Includes internal notes, the event trail, the environment snapshot captured when the ticket was opened, and the statuses this ticket may legally move to.
     * @summary Get one support ticket with the full thread
     * @param {SupportAdminApiGetSupportAdminTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public getSupportAdminTicket(requestParameters: SupportAdminApiGetSupportAdminTicketRequest, options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).getSupportAdminTicket(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The live counterpart to the ticket\'s frozen contextSnapshot: the same keys read again now, which of them changed since, plus the facts that only make sense live — last invoice issued, documents stuck in a terminal failure, last webhook received, and the shop\'s unresolved alerts.
     * @summary Read the ticket\'s shop as it stands right now
     * @param {SupportAdminApiGetSupportTicketShopStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public getSupportTicketShopState(requestParameters: SupportAdminApiGetSupportTicketShopStateRequest, options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).getSupportTicketShopState(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The working queue, sorted by first-response deadline so the most at-risk ticket is first. Filterable by status, category, priority, tier, assignee and overdue, with free text over subject, shop domain and ticket reference.
     * @summary List support tickets across all shops
     * @param {SupportAdminApiListSupportAdminTicketsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public listSupportAdminTickets(requestParameters: SupportAdminApiListSupportAdminTicketsRequest = {}, options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).listSupportAdminTickets(requestParameters.page, requestParameters.limit, requestParameters.status, requestParameters.category, requestParameters.priority, requestParameters.assignee, requestParameters.tier, requestParameters.overdue, requestParameters.search, requestParameters.scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The operator accounts that can currently sign in. Passwords are never returned.
     * @summary List the configured support operators
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public listSupportAgents(options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).listSupportAgents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Searches all three document tables by the number as the merchant\'s own document is headed, and invoices additionally by order name and order id. An order-shaped term returns the invoice together with the credit notes and cancellation invoices that hang off it. Pass shopId whenever the lookup starts from a ticket — it is what makes the shop\'s prefix and year digits interpretable.
     * @summary Find invoices, credit notes and Stornos by number or order
     * @param {SupportAdminApiLookupSupportDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public lookupSupportDocuments(requestParameters: SupportAdminApiLookupSupportDocumentsRequest, options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).lookupSupportDocuments(requestParameters.q, requestParameters.shopId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds a PUBLIC agent message, stamps the first-response time on the first reply only, and claims an unassigned ticket for the replying operator. Optionally moves the ticket to another status in the same call. Send expectedStateToken to have the reply refused if the ticket changed after it was read.
     * @summary Reply to a support ticket
     * @param {SupportAdminApiReplyToSupportTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public replyToSupportTicket(requestParameters: SupportAdminApiReplyToSupportTicketRequest, options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).replyToSupportTicket(requestParameters.id, requestParameters.createSupportAdminMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The assignee must be a configured operator; an unknown username is refused so a typo cannot park a ticket where no filter finds it.
     * @summary Assign or unassign a support ticket
     * @param {SupportAdminApiUpdateSupportTicketAssigneeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public updateSupportTicketAssignee(requestParameters: SupportAdminApiUpdateSupportTicketAssigneeRequest, options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).updateSupportTicketAssignee(requestParameters.id, requestParameters.updateSupportTicketAssigneeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refused when the ticket currently sits in a status the new category does not allow, rather than silently moving it.
     * @summary Recategorise a support ticket
     * @param {SupportAdminApiUpdateSupportTicketCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public updateSupportTicketCategory(requestParameters: SupportAdminApiUpdateSupportTicketCategoryRequest, options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).updateSupportTicketCategory(requestParameters.id, requestParameters.updateSupportTicketCategoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change a support ticket priority
     * @param {SupportAdminApiUpdateSupportTicketPriorityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public updateSupportTicketPriority(requestParameters: SupportAdminApiUpdateSupportTicketPriorityRequest, options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).updateSupportTicketPriority(requestParameters.id, requestParameters.updateSupportTicketPriorityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validated against the shared transition table and the category restriction, so the backlog statuses stay reachable only for feature requests and feedback.
     * @summary Change a support ticket status
     * @param {SupportAdminApiUpdateSupportTicketStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAdminApi
     */
    public updateSupportTicketStatus(requestParameters: SupportAdminApiUpdateSupportTicketStatusRequest, options?: RawAxiosRequestConfig) {
        return SupportAdminApiFp(this.configuration).updateSupportTicketStatus(requestParameters.id, requestParameters.updateSupportTicketStatusDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum ListSupportAdminTicketsStatusEnum {
    New = 'NEW',
    Open = 'OPEN',
    PendingCustomer = 'PENDING_CUSTOMER',
    UnderReview = 'UNDER_REVIEW',
    Planned = 'PLANNED',
    Declined = 'DECLINED',
    Resolved = 'RESOLVED',
    Closed = 'CLOSED'
}
/**
  * @export
  * @enum {string}
  */
export enum ListSupportAdminTicketsCategoryEnum {
    Question = 'QUESTION',
    Bug = 'BUG',
    FeatureRequest = 'FEATURE_REQUEST',
    Feedback = 'FEEDBACK',
    Billing = 'BILLING',
    TaxCompliance = 'TAX_COMPLIANCE',
    DataExport = 'DATA_EXPORT',
    Onboarding = 'ONBOARDING',
    Other = 'OTHER'
}
/**
  * @export
  * @enum {string}
  */
export enum ListSupportAdminTicketsPriorityEnum {
    Low = 'LOW',
    Normal = 'NORMAL',
    High = 'HIGH',
    Urgent = 'URGENT'
}
/**
  * @export
  * @enum {string}
  */
export enum ListSupportAdminTicketsTierEnum {
    Starter = 'STARTER',
    Professional = 'PROFESSIONAL',
    Business = 'BUSINESS',
    Enterprise = 'ENTERPRISE'
}
/**
  * @export
  * @enum {string}
  */
export enum ListSupportAdminTicketsScopeEnum {
    Open = 'open',
    All = 'all'
}
